import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import {
  approvalsApi,
  type SupplierApprovalRequest,
  type InputBatchApprovalRequest,
  type SeedBatchApprovalRequest,
} from "../services/approvalsApi";

// ── Suppliers (GM) ──────────────────────────────────────────────────────────
export const usePendingSuppliers = () =>
  useQuery({
    queryKey: ["suppliers", "pending"],
    queryFn: approvalsApi.getPendingSuppliers,
  });

export const useApproveSupplier = () =>
  useMutation({
    mutationFn: ({ id, request }: { id: string; request: SupplierApprovalRequest }) =>
      approvalsApi.approveSupplier(id, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["suppliers"] });
    },
  });

// ── Stock receipts (GM) ─────────────────────────────────────────────────────
export const usePendingStockReceipts = () =>
  useQuery({
    queryKey: ["stock-receipts", "pending"],
    queryFn: approvalsApi.getPendingStockReceipts,
  });

export const useApproveStockReceipt = () =>
  useMutation({
    mutationFn: ({ id, request }: { id: string; request: InputBatchApprovalRequest }) =>
      approvalsApi.approveStockReceipt(id, request),
    onSuccess: () => {
      // Approve flips a batch from Pending → Approved, which changes
      // GetAvailableBatchesAsync results — invalidate inventory and batches.
      queryClient.invalidateQueries({ queryKey: ["stock-receipts"] });
      queryClient.invalidateQueries({ queryKey: ["input-batches"] });
      queryClient.invalidateQueries({ queryKey: ["inputs"] });
    },
  });

// ── Customer seed batches (Stores Supervisor) ───────────────────────────────
export const usePendingSeedBatches = () =>
  useQuery({
    queryKey: ["seed-batches", "pending"],
    queryFn: approvalsApi.getPendingSeedBatches,
  });

export const useApproveSeedBatch = () =>
  useMutation({
    mutationFn: ({ id, request }: { id: string; request: SeedBatchApprovalRequest }) =>
      approvalsApi.approveSeedBatch(id, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["seed-batches"] });
    },
  });
